import style from "./CourseProgressBanner.module.css";
import { Link } from "react-router-dom";
import VideoBreadcrumb from "@/ui/videoBreadcrumb/VideoBreadcrumb";
import Button from "@/ui/button/Button";
import Icon from "@/ui/icon/Icon";
import ContinueWatchingStatistics from "@/features/courses/components/continueWatchingStatistics/ContinueWatchingStatistics";
import { formatTime } from "@/utils/helpers";
import UpgradeToPremium from "@/features/auth/components/upgradeToPremium/UpgradeToPremium";
import { useUser } from "@/features/auth/hooks/useUser";
import { useEffect, useState } from "react";
import "katex/dist/katex.min.css";
import Latex from "react-latex-next";

import AuthPrompt from "@/features/auth/components/authPrompt/AuthPrompt";

function videoPercentComplete(video) {
	if (video?.user_activity?.current_second_in_video && video?.duration > 0) {
		return Math.floor(
			(100 * video.user_activity.current_second_in_video) / video.duration
		);
	}
	return 0;
}

function CourseProgressBanner({ courseData }) {
	const video = courseData?.video;
	const { user, isLoggedIn } = useUser();
	const [showProgress, setShowProgress] = useState(true);

	useEffect(() => {
		if (!user?.is_subscribed) {
			setShowProgress(Math.random() < 0.5);
		}
	}, [user?.is_subscribed]);

	if (!video) {
		return null;
	}

	return (
		<div className={style.banner}>
			<div className={style.left}>
				<h2>
					{video?.user_activity?.current_second_in_video
						? "Nastavi učiti"
						: "Započni učiti"}
				</h2>
				<h1>{video.name}</h1>
				<p>
					<Latex>
						{video.description || video.module.description || ""}
					</Latex>
				</p>
				<div className={style.buttonHolder}>
					<Button
						to={`/courses/${video.module.course.slug}/${video.module.slug}/${video.slug}/`}
						type="accent"
					>
						<span>Nastavi gledati</span>
						<Icon icon="fa-arrow-right-long" />
					</Button>
				</div>
			</div>
			<div className={style.right}>
				<div className={style.videoInfo}>
					<VideoBreadcrumb video={video} />
					<Link
						to={`/courses/${video.module.course.slug}/${video.module.slug}/${video.slug}/`}
						style={{
							"--background": `url(${video.thumbnail})`,
							"--video-percent": `${videoPercentComplete(
								video
							)}%`,
						}}
						className={style.video}
					>
						{video?.user_activity?.current_second_in_video > 0 && (
							<div className={style.progress}>
								<div className={style.progressInfo}>
									<span className={style.current}>
										{formatTime(
											video?.user_activity
												?.current_second_in_video || 0
										)}
									</span>
									<span className={style.duration}>
										<span>
											{formatTime(
												video?.duration -
													(video?.user_activity
														?.current_second_in_video ||
														0)
											)}
										</span>
										<Icon icon="fa-arrow-right-to-line" />
									</span>
								</div>
							</div>
						)}
					</Link>
				</div>

				{!isLoggedIn ? (
					<AuthPrompt />
				) : video?.user_activity?.current_second_in_video === 0 &&
				  !user?.is_subscribed ? (
					<UpgradeToPremium />
				) : user?.is_subscribed ? (
					<ContinueWatchingStatistics
						courseProgress={courseData.courseProgress}
					/>
				) : showProgress ? (
					<ContinueWatchingStatistics
						courseProgress={courseData.courseProgress}
					/>
				) : (
					<UpgradeToPremium />
				)}
			</div>
		</div>
	);
}

export default CourseProgressBanner;
